import { gql } from "@apollo/client";

export const AUTH_QUERY = gql`
  mutation Auth($username: String!, $password: String!) {
    token_auth(password: $password, username: $username) {
      token
      refresh_token
      payload
    }
  }
`;

export const REFRESH_TOKEN = gql`
  mutation RefreshToken($refresh_token: String!) {
    refresh_token(refresh_token: $refresh_token) {
      refresh_token
      token
      payload
    }
  }
`;

export const REVOKE_TOKEN = gql`
  mutation RevokeToken($refresh_token: String!) {
    revoke_token(refresh_token: $refresh_token) {
      success
      message
    }
  }
`;

export const READ_IAM_QUERY = gql`
  query ReadIamQuery {
    authentication {
      iam_types
      remote_iam_enabled
    }
  }
`;

export const OKTA_AUTH_MUTATION = gql`
  mutation OktaAuth($code: String!, $state: String!) {
    okta_auth(code: $code, state: $state) {
      token
      refresh_token
      payload
    }
  }
`;
